import PrivatePolicy from './PrivatePolicy'

export default PrivatePolicy


// WEBPACK FOOTER //
// ./src/features/ProvatePolicy/components/PrivatePolicy/index.js